import { Stack, Typography, Button, FormControl } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Fragment, useState } from "react";

import { GeneralData } from "./GeneralData";
import { useForm } from "../../../hooks/useForm";
import { FormRent } from "./FormRents";
import { FormService } from "./FormService";
import { FormVariableStatus } from "./FormVariableStatus";
import { Message } from "../../../components/Message";
import { messagesEditWork } from "../../../helpers/workMessage";

export const FormEdit = ({ data, dataProduct }) => {

    const [completeForm, setCompleteForm] = useState(null)
    const [closeMessage, setCloseMessage] = useState(true)
    const navigate = useNavigate();
    const { client, contact, addressWork, status } = data;

    const { contactTel, contactEmail } = JSON.parse(client.contacts).filter(obj => obj.contactName === contact)[0];

    const [formValues, handleInputChange] = useForm(data);

    const handleSubmit = (e) => {
        e.preventDefault()
        setCompleteForm(formValues)
    }

    return (
        <FormControl component='form' className="form_containerEstimate" onSubmit={handleSubmit}>
            {!completeForm ?
                <Stack spacing={4} pt={3} pb={3} >
                    <Typography textAlign='center' variant="h5" color="primary">Editar Obra</Typography>
                    <Stack width='100%' alignItems='center' spacing={5}>
                        <Stack width='100%' alignItems='center' spacing={1}>
                            <Stack flexDirection='row' width='90%' justifyContent='space-between' flexWrap='wrap'>
                                <Typography><b>Cliente:</b> {client.name}</Typography>
                                <Typography><b>Persona de contacto:</b> {contact}</Typography>
                            </Stack>
                            <Stack flexDirection='row' width='90%' justifyContent='space-between' flexWrap='wrap' >
                                <Typography><b>Teléfono de contacto:</b> {contactTel}</Typography>
                                <Typography><b>Email de contacto:</b> {contactEmail}</Typography>
                            </Stack>
                            <Stack flexDirection='row' width='90%' justifyContent='space-between' alignItems='center' flexWrap='wrap'>
                                <Typography><b>Dirección de la obra:</b> {addressWork}</Typography>
                                <Stack flexDirection='row' alignItems='center' gap={3}>
                                    <Typography ><b>Estado actual:</b></Typography>
                                    <Typography color={(status === 'Montada') ? 'green' : 'red'}>{status}</Typography>
                                </Stack>
                            </Stack>
                        </Stack >

                        <GeneralData formValues={formValues} handleInputChange={handleInputChange} />
                        <FormRent formValues={formValues} handleInputChange={handleInputChange} dataProduct={dataProduct} />
                        <FormService formValues={formValues} handleInputChange={handleInputChange} dataProduct={dataProduct} />
                        <FormVariableStatus formValues={formValues} handleInputChange={handleInputChange} />

                    </Stack >
                    <Stack />
                    <Stack flexDirection='row' flexWrap='wrap' justifyContent='flex-end' width='95%' gap={5} mb={2}>
                        <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={() => navigate('/works')}>Cancelar</Button>
                        <Button sx={{ width: '100px' }} variant="contained" size='small' type='submit'>Guardar</Button>
                    </Stack>
                </Stack>
                :
                <Fragment>
                    {closeMessage && <Message messages={messagesEditWork} method='PUT' setIsCreate={setCloseMessage} body={completeForm} />}
                </Fragment>
            }
        </FormControl>
    )
}